import { useEffect, useState } from 'react';

export default function UserProfileButton() {
  const [hasJwt, setHasJwt] = useState(false);

  useEffect(() => {
    setHasJwt(!!localStorage.getItem('auth_token'));
  }, []);

  // ✅ If authenticated via JWT → hide login button
  if (hasJwt) {
    return null;
  }

  // ❌ Otherwise show existing login behavior
  return 'Log in';
}
